/**
 * Servicio de datos de Carrera (desempeño) del colaborador.
 *
 * Estos datos se consultan en TIEMPO REAL cada vez que se despliega el toggle
 * "Detalle de Carrera". No se persisten: solo se muestran.
 *
 * El endpoint (info_usuario de MercadoLibre) recibe `username` (del detalle del
 * colaborador) y `legajo` (que corresponde al ID del reporte) y devuelve el
 * objeto de carrera con el shape usado por CareerDetail (full_name, on_pip,
 * pip_detail, exit_history, data, ...).
 */

import { getInfoUsuario } from "../../../../../apis";

/**
 * Consulta los datos de carrera del colaborador en tiempo real.
 * @param {Object} params
 * @param {string} params.username Username del colaborador.
 * @param {string|number} params.legajo ID del reporte.
 * @returns {Promise<object|null>} Objeto de carrera, o null si no hay datos.
 */
export const fetchCareerData = ({ username, legajo }) =>
  getInfoUsuario({ username, legajo });
